export default "__VITE_ASSET__CZ4gAc4z__"